import { Injectable, inject, signal } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type { RiskAssessmentAdapter } from '@app/modules/management/models/risk-assessment.model';
import { RISK_ASSESSMENT_PATH } from '@app/shared/constants/api-route.config';
import type { ItemResponse } from '@app/shared/services/mixins/crud.service';
import { WithCrudService } from '@app/shared/services/mixins/crud.service';
import { RestService } from '@app/shared/services/rest.service';
import { ToastNotificationService } from '@app/shared/services/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class RiskAssessmentService extends classes(WithCrudService<RiskAssessmentAdapter>) {
    protected endpoint = RISK_ASSESSMENT_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);

    // FIXME: This is the risk assessment details.
    //        This should ONLY be used when opening a risk assessment page in the Registry
    readonly item = signal<RiskAssessmentAdapter>(null); // interactions is not present in simple schema

    copyFromPipelineVersion(payload: {
        name: string;
        pipelineVersionId: number;
        sourcePipelineVersionId: number;
    }): Observable<ItemResponse<RiskAssessmentAdapter>> {
        return this.api.post<ItemResponse<RiskAssessmentAdapter>>(`${this.endpoint}copy`, payload);
    }
}
